import React from 'react';
import HighlightAction from '../../actions/highlight-action';
import Isvg from '../../../vendor/react-inlinesvg';
import { VstButton } from 'vstui';
import { Dialog, Select, Checkbox, Button, TextField } from "@vitalsource/vstui";
import styled from "styled-components";
import Dispatcher from "../../dispatcher";
import { isEmojiMarker } from "./../reader/highlights/emoji-reactions/helpers"

const MAX_HIGHLIGHT_LENGTH = 50 ;

const labelSort = (a, b) => {
  if (a.label > b.label) {
    return 1;
  }
  if (a.label < b.label) {
    return -1;
  }
  return 0;
};

const InlineSelect = styled(Select)`
  display: inline-block;
  vertical-align: middle;
  margin: 0;
`;

const InlineCheckBox = styled(Checkbox)`
  display: inline-flex;
  width: 22%;
  margin: 0;
  vertical-align: middle;
`;

const ColorMarkerButton = styled(Button)`
  button {
    border-radius: 22px;
    height: 25px;
    width: 25px;
    padding: 0;
    margin: 0 12px 0 0;
  }
  &.selected {
    button {
      border-width: 3px;
    }
  }
`;

class ManageHighlighters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newHighlighterName: "",
      userHighlighters: [],
      selectedHighlighter: false,
      highlighterToDelete: false,
      currentSmallScreen: Fraction.Helpers.isSmallScreen(),
      priacyNotifications: false,
      hideActionButtons: false,
    };

    this._resetManage = this._resetManage.bind(this);
    this._updateNewHighlighterName = this._updateNewHighlighterName.bind(this);
    this._getUserHighlighters = this._getUserHighlighters.bind(this);
    this._setSelectedHighlighter = this._setSelectedHighlighter.bind(this);
    this._tryToDelete = this._tryToDelete.bind(this);
    this._getFirstSelectedToMerge = this._getFirstSelectedToMerge.bind(this);
    this._cancelDelete = this._cancelDelete.bind(this);
    this._showHighlighterForm = this._showHighlighterForm.bind(this);
    this._startCreateHighlighter = this._startCreateHighlighter.bind(this);
    this._selectHighlighter = this._selectHighlighter.bind(this);
    this._unsetHighlighter = this._unsetHighlighter.bind(this);
    this._setPrivate = this._setPrivate.bind(this);
    this._setPublic = this._setPublic.bind(this);
    this._updateColor = this._updateColor.bind(this);
    this._findNextName = this._findNextName.bind(this);
    this._saveHighlighter = this._saveHighlighter.bind(this);
    this._deleteHighlighter = this._deleteHighlighter.bind(this);
    this._resetHighlights = this._resetHighlights.bind(this);
    this._confirmDeleteHighlighter = this._confirmDeleteHighlighter.bind(this);
    this._mergeHighlighter = this._mergeHighlighter.bind(this);
    this._confirmMergeHighlighter = this._confirmMergeHighlighter.bind(this);
    this._nameForId = this._nameForId.bind(this);
    this._selectMergeOption = this._selectMergeOption.bind(this);
    this._scrollToHighlighter = this._scrollToHighlighter.bind(this);
    this._updatetHighlighter = this._updatetHighlighter.bind(this);
    this._insertHighlighter = this._insertHighlighter.bind(this);
    this._removeHighlighter = this._removeHighlighter.bind(this);
    this._redraw = this._redraw.bind(this);
    this._onInputChange = this._onInputChange.bind(this);
    this._closeModal = this._closeModal.bind(this);

    this.highlighterNameRef = React.createRef();
  }

  componentDidMount() {
    this.mounted = true;
    this._getUserHighlighters();
    $(window).on('resize', this._resetManage);
  }

  componentWillUnmount() {
    $(window).unbind('resize', this._resetManage);
    this.mounted = false;
  }

  _closeModal() {
    this.props.onClose 
      ? this.props.onClose() 
      : Dispatcher.emit(Dispatcher.CLOSE_MODAL);
  }

  _resetManage() {
    if (this.state.currentSmallScreen!==Fraction.Helpers.isSmallScreen()) {
      this._unsetHighlighter();
      this.setState({currentSmallScreen: Fraction.Helpers.isSmallScreen()});
    }
  }

  _updateNewHighlighterName(e) {
    const val = e.currentTarget.value;
    if (val.length <= MAX_HIGHLIGHT_LENGTH) {
      this.state.selectedHighlighter.newLabel = e.currentTarget.value;
      this.setState({selectedHighlighter: this.state.selectedHighlighter});
    }
  }

  _getUserHighlighters() {
    Fraction.Helpers.addLoader(".existing-highlighters");
    Fraction.Helpers.addLoader(".null-screen");
    Jigsaw.User.getMarkers((response) => {
      if (response.isSuccess()){
        Fraction.Helpers.removeLoader(".existing-highlighters");
        Fraction.Helpers.removeLoader(".null-screen");

        // remove this when jigsaw returns a real boolean....
        const booleanMap = { "false": false, "true": true };
        let markers = response.data.markers.map(marker => {
          marker.shared = booleanMap[marker.shared];
          marker.friendsOnly = booleanMap[marker.friendsOnly];
          return marker;
        }).sort(labelSort).filter((m) => {
          return !isEmojiMarker(m)
        });
        
        this.setState({
          userHighlighters: markers,
          colorOptions: response.data.colorOptions,
        });
      } else {
        Fraction.Helpers.removeLoader(".existing-highlighters");
        Fraction.Helpers.removeLoader(".null-screen");
        this.setState({
          unavailable: true,
          userHighlighters: [],
          selectedHighlighter: false,
          highlighterToDelete: false,
        });
      }
    });
  }

  _setSelectedHighlighter(selectedHighlighter) {
    selectedHighlighter.newLabel = selectedHighlighter.label;
    selectedHighlighter.newFriendsOnly = selectedHighlighter.friendsOnly;
    selectedHighlighter.newShared = selectedHighlighter.shared;
    selectedHighlighter.newColor = selectedHighlighter.vstColor;
    if (this.state.selectedHighlighter){
      const postShowFunction = () => {
        if (this.state.selectedHighlighter !== selectedHighlighter) {
          this.setState({
            selectedHighlighter,
            tryingToDelete: this.state.delayTryingToDelete,
            delayTryingToDelete: false,
            highlighterToDelete: false,
            confirmingDelete: false,
            confirmingMerge: false,
          });
          this._showHighlighterForm(selectedHighlighter.globalId);
        } else {
          this.setState({
            selectedHighlighter: false,
            highlighterToDelete: false,
            tryingToDelete: false,
            confirmingDelete: false,
            confirmingMerge: false,
            changeColorBG: false,
          });
        }
      };
      $(".highlighter-form").slideUp(postShowFunction);
    } else {
      setTimeout(() => {
        this.setState({
          selectedHighlighter: selectedHighlighter,
          tryingToDelete: this.state.delayTryingToDelete,
          delayTryingToDelete: false,
          highlighterToDelete: false,
          confirmingDelete: false,
          confirmingMerge: false,
          changeColorBG: true,
        });
        this._showHighlighterForm(selectedHighlighter.globalId);
      }, 0);
    }
  }

  _tryToDelete(e) {
    e.stopPropagation();
    e.preventDefault();
    const { selectedHighlighter={}, userHighlighters } = this.state;
    const index = $(e.currentTarget).attr('data-index');
    if (selectedHighlighter && selectedHighlighter.globalId === userHighlighters[index].globalId) {
      this.setState({
        tryingToDelete: true,
        confirmingMerge: false,
        preserveAfterCancel: true,
        confirmingDelete: false,
        selectedToMerge: this._getFirstSelectedToMerge(userHighlighters[index]),
      });
    } else {
      this._selectHighlighter(e);
      this.setState({
        tryingToDelete: false,
        delayTryingToDelete: true,
        confirmingDelete: false,
        confirmingMerge: false,
        preserveAfterCancel: false,
        selectedToMerge: this._getFirstSelectedToMerge(userHighlighters[index]),
      });
    }
  }

  _getFirstSelectedToMerge(highlighter) {
    if (this.state.userHighlighters.length >= 2) {
      const firstToMerge = this.state.userHighlighters[0].globalId;
      if (firstToMerge === highlighter.globalId) {
        return this.state.userHighlighters[1].globalId;
      }
      return firstToMerge;
    }
  }

  _cancelDelete(e) {
    if (!this.state.preserveAfterCancel) {
      this._unsetHighlighter();
    }
    this.setState({
      tryingToDelete: false,
      delayTryingToDelete: false,
      preserveAfterCancel: false
    });
  }

  _showHighlighterForm(globalId) {
    Fraction.Helpers.runAfterRender(() => {
      $(".highlighter-form").slideDown(() => {
        if (globalId) {
          this._scrollToHighlighter($("li[data-globalid='"+globalId+"']").get(0));
        }
      });
    });
  }

  _startCreateHighlighter() {
    if (this.state.colorOptions && this.state.colorOptions.length) {
      const newHighlighter = {
        label: "",
        shared: false,
        vstColor: this.state.colorOptions[0].vstColor,
        vstColorDark: this.state.colorOptions[0].vstColorDark,
        newHighlighter: true,
      };
      this._setSelectedHighlighter(newHighlighter);
      setTimeout(() => {
        document.querySelector(".color-options > .marker");
      }, 1000);  
    }
    if (this.state.currentSmallScreen) {
      this.setState({
        hideActionButtons: true
      });
    }
  }

  _onInputChange(e) {
    let privacyChecked = document.getElementById("privacyCheckbox").checked;
    if (privacyChecked) {
      this._setPublic(e);
    } else {
      this._setPrivate(e);
    }
  } 

  _selectHighlighter(e) {
    if (this.state.userHighlighters) {
      if (Fraction.Helpers.isSmallScreen()){
        this.setState({
          hideActionButtons: true
        });
      }
      const index = $(e.currentTarget).attr('data-index');
      this._setSelectedHighlighter(this.state.userHighlighters[index]);
    }
  }

  _unsetHighlighter(e) {
    if (Fraction.Helpers.isSmallScreen()){
      $(".highlighter-form").hide();
      this.setState({
        selectedHighlighter: false,
        highlighterToDelete: false,
        changeColorBG: false,
        hideActionButtons: false,
        tryingToDelete: false
      });
    } else {
      $(".highlighter-form").slideUp(() => {
        this.setState({
          selectedHighlighter: false,
          highlighterToDelete: false,
          changeColorBG: false,
        });
      });
    }
    const globalId = this.state.selectedHighlighter.globalId;
    $(`[data-globalid="${globalId}"]`).find('button').first().focus();
  }

  _setPrivate(e) {
    if (this.state.selectedHighlighter) {
      const selectedHighlighter = this.state.selectedHighlighter;
      selectedHighlighter.newShared = false;
      this.setState({selectedHighlighter});
    }
  }

  _setPublic(e) {
    if (this.state.selectedHighlighter) {
      const selectedHighlighter = this.state.selectedHighlighter;
      selectedHighlighter.newShared = true;
      this.setState({selectedHighlighter});
    }
  }

  _updateColor(e) {
    const selectedHighlighter = this.state.selectedHighlighter;
    if (selectedHighlighter) {
      selectedHighlighter.newColor = $(e.currentTarget).data('selectcolor');
      this.setState({selectedHighlighter});
    }
  }

  _findNextName(name) {
    // NOTE Regex is not being used anywhere.
    // maybe it should be used togther with the match function
    const regex = new RegExp(name, "g");
    const inc = this.state.userHighlighters.reduce((counter, uh) => {
      if (uh.label.match(name)) {
        return counter + 1;
      }
      return counter;
    }, 0);
    return inc === 0 ? name : `${name} ${inc + 1}`;
  }

  updateMarker(id, updatedMarker) {
    Jigsaw.User.updateMarker(id, updatedMarker, (response) => {
      Fraction.Helpers.removeLoader(".highlighter-form");
      if (response.isSuccess()){
        this._unsetHighlighter();

        // remove this when jigsaw returns a real boolean....
        const booleanMap = { "false": false, "true": true };
        const markers = Object.assign(response.data, {
          shared: booleanMap[response.data.shared],
          friendsOnly: booleanMap[response.data.friendsOnly],
        });
        this._insertHighlighter(markers);
        this._resetHighlights();
        Fraction.Reporter.gaEvent("highlighters/manage/update-highlighter");
      } else {
        Fraction.Helpers.toast(i18n.t('reader.notebook.notes-highlights-error'), {type: "error", dismissable: true});
        this.setState({
          unavailable: true,
          userHighlighters: [],
          selectedHighlighter: false,
          highlighterToDelete: false,
        });
      }
    });
  }

  _saveHighlighter() {
    if (this.state.selectedHighlighter){
      const selectedHighlighter = this.state.selectedHighlighter;
      selectedHighlighter.friendsOnly = selectedHighlighter.newFriendsOnly;
      selectedHighlighter.shared = selectedHighlighter.newShared;
      selectedHighlighter.color = selectedHighlighter.newColor;
      selectedHighlighter.vstColor = selectedHighlighter.newColor;

      if (selectedHighlighter.newLabel.length) {
        selectedHighlighter.label = selectedHighlighter.newLabel;
      } else {
        const colorName = Fraction.Helpers.getColorName(selectedHighlighter.color);
        selectedHighlighter.label = this._findNextName(colorName);
      }
      Fraction.Helpers.addLoader(".highlighter-form");
      if (selectedHighlighter.globalId){
        this.updateMarker(selectedHighlighter.globalId, selectedHighlighter);
      } else {
        Jigsaw.User.createMarker(selectedHighlighter, (response) => {
          Fraction.Helpers.removeLoader(".highlighter-form");
          if (response.isSuccess()){
            this._unsetHighlighter();

            // remove this when jigsaw returns a real boolean....
            const booleanMap = { "false": false, "true": true };
            const markers = Object.assign(response.data, {
              shared: booleanMap[response.data.shared],
              friendsOnly: booleanMap[response.data.friendsOnly],
            });

            this._insertHighlighter(markers);
            this._resetHighlights();
          } else {
            Fraction.Helpers.toast(i18n.t('reader.notebook.notes-highlights-error'), {type: "error", dismissable: true});
            this.setState({
              unavailable: true,
              userHighlighters: [],
              selectedHighlighter: false,
              highlighterToDelete: false
            });
          }
        });
        Fraction.Reporter.gaEvent("highlighters/manage/add-highlighter");
      }
    }
  }

  _deleteHighlighter() {
    const highlighterToDelete = this.state.selectedHighlighter || this.state.highlighterToDelete;
    if (highlighterToDelete && highlighterToDelete.globalId){
      const id = highlighterToDelete.globalId;
      Jigsaw.User.deleteMarker({id}, (response) => {
        if (response.isSuccess()){
          this._removeHighlighter(id);
          this._resetHighlights();
        } else {
          Fraction.Helpers.toast(i18n.t('reader.notebook.notes-highlights-error'), {type: "error", dismissable: true});
          this.setState({
            unavailable: true,
            userHighlighters: [],
            selectedHighlighter: false,
            highlighterToDelete: false
          });
        }
      });
      Fraction.Reporter.gaEvent("highlighters/manage/delete-highlighter");
    }
  }

  _resetHighlights() {
    Fraction.Helpers.removeLoader(".existing-highlighters");
    HighlightAction.resetHighlights(this.props.isbn);
  }

  _confirmDeleteHighlighter(e) {
    this.setState({confirmingDelete: true});
  }

  _mergeHighlighter() {
    const highlighterToDelete = this.state.selectedHighlighter || this.state.highlighterToDelete;
    if (highlighterToDelete && highlighterToDelete.globalId){
      const id = highlighterToDelete.globalId;
      const mergeWith = this.state.selectedToMerge;
      Jigsaw.User.deleteMarker({id, mergeWith}, (response) => {
          if (this.state.selectedToMerge) {
            this.setState({selectedToMerge: false, flashId: mergeWith});
          }
          if (response.isSuccess()){
            Fraction.Helpers.addLoader(".existing-highlighters");
            this._removeHighlighter(id);
            this._resetHighlights();
          } else {
            Fraction.Helpers.toast(i18n.t('reader.notebook.notes-highlights-error'), {type: "error", dismissable: true});
            this.setState({
              unavailable: true,
              userHighlighters: [],
              selectedHighlighter: false,
              highlighterToDelete: false,
            });
          }
        }
      );
      Fraction.Reporter.gaEvent("highlighters/manage/merge-highlighter");
    }
  }

  _confirmMergeHighlighter(e) {
    this.setState({confirmingMerge: true});
  }

  _nameForId(id) {
    const foundHighlighter = this.state.userHighlighters.find(highlighter => {
      return (highlighter.globalId === id);
    });
    if (foundHighlighter) {
      return foundHighlighter.label;
    } else {
      return "";
    }
  }

  _selectMergeOption(e) {
    this.setState({selectedToMerge: e.currentTarget.value});
  }

  _scrollToHighlighter(element) {
    if (element){
      const $highlighters = $(".manage-highlighters");
      const $element = $(element);
      //const offset = 10;
      const height = element.offsetTop + $element.innerHeight();
      const top = $highlighters.scrollTop() + $highlighters.innerHeight();

      if (height > top) {
        const scrollTop = element.offsetTop - $highlighters.innerHeight() + $element.innerHeight();
        $highlighters.animate({
          scrollTop: scrollTop,
        }, 500, 'swing');
      }
    }
  }

  _updatetHighlighter(index, marker) {
    const highlighters = this.state.userHighlighters;
    highlighters[index] = Object.assign(highlighters[index], marker);
    this.setState({
      userHighlighters: highlighters.sort(labelSort),
      flashId: marker.globalId,
    });
  }

  _insertHighlighter(marker) {
    const userHighlighters = this.state.userHighlighters;
    if (userHighlighters) {
      const markerIndex = userHighlighters.findIndex(h => h.globalId === marker.globalId);

      if (markerIndex !== -1) {
        this._updatetHighlighter(markerIndex, marker);
      } else {
        userHighlighters.push(marker);
        this.setState({
          userHighlighters: userHighlighters.sort(labelSort),
          flashId: marker.globalId,
        });
      }
    }
  }

  _removeHighlighter(globalId) {
    const userHighlighters = this.state.userHighlighters;

    if (userHighlighters) {
      const newUserHighlighters = userHighlighters.filter(h => h.globalId !== globalId);
      const updatedState = {
        userHighlighters: newUserHighlighters,
        selectedHighlighter: false,
        highlighterToDelete: false,
        confirmingDelete: false,
        confirmingMerge: false,
        tryingToDelete: false,
        delayTryingToDelete: false,
        changeColorBG: false,
      };

      if (newUserHighlighters.length === userHighlighters.length) {
        updatedState.userHighlighters = userHighlighters.sort(labelSort);
      } else if (!Fraction.Helpers.isSmallScreen()) {
        return $(".highlighter-form").parent().slideUp(() => this.setState(updatedState));
      }

      this.setState(updatedState);
    }
  }

  _redraw() {
    setTimeout(() => {
      if (this.mounted) {
        this.forceUpdate();
      }
    }, 0);
  }

  renderConfirmMerge() {
    return (
      <div>
        <span>
          {window.toHTML(i18n.t('highlighters.merge-desc', {
            from: this.state.highlighterToDelete.label,
            to: this._nameForId(this.state.selectedToMerge)
          }))}
        </span>
      </div>
    );
  }

  renderConfirmDelete() {
    return (
      <div>
        <span>
          {window.toHTML(i18n.t('highlighters.delete-desc', {name: this.state.highlighterToDelete.label}))}
        </span>
      </div>
    );
  }

  renderDeleteOrMerge() {
    return (
      <div>
        <span>
          {window.toHTML(i18n.t('highlighters.delete-or-merge-desc'))}
        </span>
        {this._getMergeableMarkers()}
      </div>
    );
  }

  _getMergeableMarkers() {
    if (this.state.selectedToMerge) {
      return (
        <span>
          <InlineSelect 
            id="merging-options"
            label={i18n.t("highlighters.delete-or-merge-highlighter")}
            className="merge-options" 
            labelHidden
            onChange={this._selectMergeOption}
          >
            {this.state.userHighlighters.reduce((acc, marker) => {
              if (marker.globalId !== this.state.selectedHighlighter.globalId &&
                  marker.globalId !== this.state.highlighterToDelete.globalId) {

                acc.push(
                  <option value={marker.globalId}>{marker.label}</option>
                );
              }
              return acc;
            }, [])}
          </InlineSelect>
        </span>);
    }
  }

  _getSharingSelection() {
    if (this.state.selectedHighlighter.newShared) {
      return 2;
    }
    return 0;
  }

  toogleButton(label, imageUrl) {
    return (
      <span>
          <span className="offScreen">{label}</span>
          <Isvg src={imageUrl} />
      </span>
    );
  }

  renderSharingDescription() {
    if (this.state.selectedHighlighter) {
      if (this.state.selectedHighlighter.newShared){
        return i18n.t("highlighters.public-description");
      }
      if (Fraction.User.ssoOnly && !Fraction.Brand.AccountCompletion.ssoOnly){
        return i18n.t("highlighters.cannot-share");
      }
      return i18n.t("highlighters.private-description");
    }
  }

  renderPrivacy() {
    if ((!Fraction.Brand.AccountCompletion.ssoOnly || !Fraction.User.ssoOnly) && Fraction.Brand.Sharing.enabled) {
      return (
        <div aria-hidden={true} id="field-description" className="toggle-description">
          {window.toHTML(this.renderSharingDescription())}
        </div>
      );
    }
  }

  renderColorOptions() {
    const colors = this.state.colorOptions.map(marker => {
      let sharingImage = "private";
      if (this.state.selectedHighlighter.newShared) {
        sharingImage = "public";
      }
      const markerStyle = {
        backgroundColor: marker.vstColor,
        borderColor: marker.vstColorDark
      };
      const selected = this.state.selectedHighlighter.newColor === marker.vstColor;
      const color = Fraction.Helpers.getColorName(marker.vstColor);
      const colorTextName = this._findNextName(color + i18n.t("highlighters.highlighter"));
      return (
        <ColorMarkerButton 
                className={selected && "selected " + sharingImage}
                key={"marker-color-option-" + marker.vstColor}
                style={markerStyle}
                data-selectcolor={marker.vstColor}
                aria-pressed={selected}
                onClick={this._updateColor}
                naked
                inline
                label={colorTextName}>
           <span className="offScreen">
             {colorTextName}
           </span>
        </ColorMarkerButton>
      );
    });

    return (
      <div className="color-options">
        {colors}
      </div>
    );
  }

  renderDeleteForm() {
    const highlighter = this.state.selectedHighlighter;
    const optionButton = (classes, label, callback) => (
      <VstButton className={`submit ${classes}`} onClick={callback}>
        {label}
      </VstButton>
    );

    if (this.state.tryingToDelete && this.state.userHighlighters.length){
      if (this.state.confirmingDelete){
        return (
          <div className="delete-form" tabIndex="0">
            <div className="delete-title">{i18n.t("highlighters.merge")}</div>
            <div className="delete-message">
              {i18n.t("highlighters.delete-desc", {name: highlighter.label})}
            </div>
            <div className="delete-action-options-delete">
              {optionButton("delete-highlighter", i18n.t("highlighters.delete"), this._deleteHighlighter)}
            </div>
          </div>
        );
      } else if (this.state.confirmingMerge){
        return (
          <div className="delete-form" tabIndex="0">
            <div className="delete-title">{i18n.t("highlighters.merge")}</div>
            <div className="delete-message">
              {i18n.t("highlighters.merge-desc", {
                from: highlighter.label,
                to: this._nameForId(this.state.selectedToMerge)})
              }
            </div>
            <div className="delete-action-options-merge">
              {this.state.selectedToMerge &&
                optionButton("merge-highlighter", i18n.t("highlighters.merge"), this._mergeHighlighter)}
            </div>
          </div>
        );
      } else {

        return (
          <div className="delete-form" tabIndex="0">
            {optionButton("delete perm-delete", i18n.t("highlighters.perm-delete-highlighter"), this._confirmDeleteHighlighter)}
            <div className="perm-delete-or"><span>{i18n.t("highlighters.or")}</span></div>
            <div>
              <span className="merge-delete-with">{i18n.t("highlighters.merge-with")}</span>
              {this._getMergeableMarkers()}
              {this.state.selectedToMerge && optionButton("merge", i18n.t("highlighters.merge"), this._confirmMergeHighlighter)}
            </div>
          </div>
        );
      }
    }
  }

  renderHighlightForm() {
    const highlighter = this.state.selectedHighlighter;
    const colorName = Fraction.Helpers.getColorName(highlighter.newColor);
    return (
      <div className={`highlighter-form ${this.state.tryingToDelete ? "trying-to-delete" : ""}`} style={{display: 'none'}}>
        {this.renderDeleteForm()}

        {!this.state.tryingToDelete &&
          <div className="highlighter-select" aria-hidden={this.state.tryingToDelete}>
          {this.renderColorOptions()}
            <div className="highlighterNameInput">        
              <TextField id="highlighterEmail"
                        label={i18n.t("highlighters.highlighter-name")}
                        ref={this.highlighterNameRef}
                        value={highlighter.newLabel}
                        onChange={this._updateNewHighlighterName}
                        type="text" />
              {Fraction.Brand.Sharing.enabled && 
                <InlineCheckBox id="privacyCheckbox"
                          className="privacyCheckbox"
                          label={window.toHTML(i18n.t('highlighters.public-checkbox', {url: "/img/public_icon_gray.svg"}))}
                          data-key="privacy"
                          onChange={this._onInputChange}
                          checked={this.state.selectedHighlighter.newShared}
                          aria-describedby="field-description" />
              }
            </div>
            {this.renderPrivacy()}
            {!this.state.hideActionButtons &&
              <div className="action-options">
                <VstButton className="noButton submit cancel linkGray" onClick={this._unsetHighlighter}>
                  {i18n.t("base.cancel")}
                </VstButton>
                <VstButton className="submit save" onClick={this._saveHighlighter}>
                  {i18n.t("base.save")}
                </VstButton>
              </div>
            }
          </div>
        }
      </div>
    );
  }

  renderHighlightList() {
    if (this.state.userHighlighters && this.state.userHighlighters.length>0){
      const highlighter = this.state.selectedHighlighter;
      return (
        <ul className="existing-highlighters noList">
          {this.state.userHighlighters.map((marker, i) => {
            let sharingImage = "private";
            if (marker.shared) {
              sharingImage = "public";
            }
            const markerStyle = {
              backgroundColor: marker.vstColor,
              borderColor: marker.vstColorDark
            };
            var selected = highlighter && highlighter.globalId === marker.globalId;
            let changeColorBG = "";
            if (this.state.changeColorBG && !selected) {
              changeColorBG = " color-disable";
            }
            let hideHighlighters = {};
            if ((this.state.selectedHighlighter.newHighlighter || (this.state.tryingToDelete && !selected)) && this.state.currentSmallScreen) {
              hideHighlighters = {display: 'none'};
            }
            return (
              <li key={marker.globalId}
                  data-globalid={marker.globalId}
                  className={(this.state.flashId === marker.globalId ? "flash" : "") + changeColorBG}
                  style={hideHighlighters}>
                  <span className={"existing-highlighters-item " + (this.state.selectedHighlighter.newHighlighter ? "newHighlighterOpen " : "") + (selected ? " selected" : "")}>
                  <button data-index={i}
                          aria-expanded={!this.state.tryingToDelete && selected}
                      className={"single-highlighter noButton" + (selected ? " selected" : "")}
                          onClick={this._selectHighlighter}>
                    <div className={"marker " + sharingImage}
                         style={markerStyle}
                         data-markerid={marker.globalId}
                         data-selectcolor={marker.darkColor}>
                      <span className="offScreen">
                          {Fraction.Helpers.getColorName(marker.vstColor) + i18n.t('highlighters.highlighter')}
                      </span>
                    </div>
                    <div className="highlighter-name">{marker.label}</div>
                  </button>
                  {(this.state.userHighlighters.length > 1) && !(this.state.tryingToDelete && selected) &&
                    <button aria-expanded={!!(this.state.tryingToDelete && selected)} 
                        className={"highlighter-delete noButton" + (selected ? " selected" : "")}
                            data-index={i}
                            onClick={this._tryToDelete}>
                      <span>{i18n.t("highlighters.remove")}</span>
                    </button>
                  }
                  {this.state.tryingToDelete && selected &&
                    <button aria-expanded={!!(this.state.tryingToDelete && selected)}
                            onClick={this._cancelDelete}
                            data-index={i}
                        className={"highlighter-cancel noButton" + (selected ? " selected" : "")}>
                      <span>{i18n.t("base.cancel")}</span>
                    </button>
                  }
                </span>
                {selected && this.renderHighlightForm()}
              </li>
              )
          })}
        </ul>
      );
    } else {
      if (!this.state.unavailable) { // notes server is up!
        return (
          <div className="null-screen">
            <div>
              <Isvg className="watkins" src="/img/highlighters_null.svg" />
            </div>
            <div className="error-desc">{window.toHTML(i18n.t('highlighters.begin-by-adding'))}</div>

          </div>
        );
      } else { // notes server is :(
        return (
          <div className="null-screen">
            <div>
              {Fraction.Brand.Graphics.watkins ?
                <Isvg className="watkins" src="/img/prop_laptop_no.svg" /> :
                <Isvg className="watkins null" src="" />
              }
            </div>
            <div className="error-desc">{i18n.t('reader.notebook.notes-info-error')}</div>
          </div>
        );
      }
    }
  }

  render() {
    const selectedHighlighter = this.state.selectedHighlighter;
    var selected = selectedHighlighter && selectedHighlighter.globalId;
    let hideHighlighters = {};
    if ((this.state.selectedHighlighter.newHighlighter || this.state.tryingToDelete) && this.state.currentSmallScreen) {
      hideHighlighters = {display: 'none'};
    }
    const shouldShowButtons = this.state.currentSmallScreen && this.state.selectedHighlighter;
    return (
      <Dialog
        open
        onRequestClose={this._closeModal}
        size="large"
        darkHeader
        rootSelector="#bookshelf"
        title={i18n.t('highlighters.manage')}
        requireInteraction={this.state.currentSmallScreen && this.state.selectedHighlighter}
        primaryActionButton={shouldShowButtons && !this.state.tryingToDelete ? {
          label: i18n.t('base.save'),
          onClick: this._saveHighlighter
        } : false}
        secondaryActionButton={shouldShowButtons ? {
          label: i18n.t('base.cancel'),
          onClick: this._unsetHighlighter
        } : false}
      >
        <div className={"manage-highlighters"}>
          {selectedHighlighter && selectedHighlighter.newHighlighter && this.renderHighlightForm()}
          {this.renderHighlightList()}
        </div>
          <div className={"add-highlighter"+((selected || this.state.changeColorBG) ? " color-disable" : "")} style={hideHighlighters}>
            {!this.state.unavailable && !shouldShowButtons &&
            <button className="noButton" disabled={selectedHighlighter} aria-expanded={!!selectedHighlighter} onClick={this._startCreateHighlighter}>
              <Isvg className="circlePlus" src="/img/circle_plus_blue.svg" />
              <span>{i18n.t("highlighters.add-highlighter")}</span>
            </button>}
          </div>
      </Dialog>
    );
  }
}

ManageHighlighters.propTypes = {};

ManageHighlighters.defaultProps = {};

module.exports = ManageHighlighters;
